var c = Object.defineProperty;
var o = (n, s, t) => s in n ? c(n, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[s] = t;
var a = (n, s, t) => o(n, typeof s != "symbol" ? s + "" : s, t);
import { HttpClient as i, httpClient as l } from "../../httpClient.js";
class d extends i {
  constructor() {
    super(...arguments);
    a(this, "slotsEndpoint", "/user-availability-slots");
    a(this, "callsEndpoint", "/scheduled-calls");
  }
  async getAvailabilitySlots(t) {
    return l.get(this.slotsEndpoint, { params: t });
  }
  async createAvailabilitySlot(t) {
    return l.post(this.slotsEndpoint, t);
  }
  async createBulkSlots(t) {
    return l.post(`${this.slotsEndpoint}/bulk`, t);
  }
  async deleteAvailabilitySlot(t) {
    return l.delete(`${this.slotsEndpoint}/${t}`);
  }
  async bookSlot(t, e) {
    return l.post(`${this.slotsEndpoint}/${t}/book`, { courseId: e });
  }
  async getScheduledCalls(t) {
    return l.get(this.callsEndpoint, { params: t });
  }
  async getTodayScheduledCalls(t) {
    return l.get(`${this.callsEndpoint}/today`, {
      params: { timezone: t }
    });
  }
  async cancelScheduledCall(t, e) {
    return l.post(`${this.callsEndpoint}/${t}/cancel`, { reason: e });
  }
  async studentCancelScheduledCall(t, e) {
    return l.post(`${this.callsEndpoint}/${t}/student-cancel`, {
      reason: e
    });
  }
  async acceptScheduledCall(t) {
    return l.post(`${this.callsEndpoint}/${t}/accept`, {});
  }
  async rejectScheduledCall(t, e) {
    return l.post(`${this.callsEndpoint}/${t}/reject`, { reason: e });
  }
}
const u = new d();
export {
  u as default
};
